'use client'

import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/shared/components/ui/sheet'
import { MenuIcon } from 'lucide-react'
import { Link, usePathname } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'

import { MobileCategorySection } from './mobile-category'
import { MobileLanguageSelector } from './mobile-language-selector'
import Image from 'next/image'
import { LogoIconWithText } from '../../../../../public/header/logo'

export function MobileMenu({ locale }: { locale: string }) {
  const t = useTranslations('header')
  const pathname = usePathname()
  const cleanedPath = pathname.replace(`/${locale}`, '') || '/'

  const isActive = (href: string) => {
    return cleanedPath === href
  }

  return (
    <Sheet>
      <SheetTrigger asChild>
        <button className='flex items-center justify-center w-10 h-10'>
          <MenuIcon className='w-6 h-6 text-[#212C34]' />
        </button>
      </SheetTrigger>

      <SheetContent side='left' className='w-[85%] p-6'>
        <SheetHeader>
          <div className='flex gap-2 items-center justify-center'>
            <Image src={'/logo.png'} width={25} height={25} alt='logo icon' />
            <SheetTitle className='text-2xl'>{t('navigation')}</SheetTitle>
          </div>
        </SheetHeader>

        {/* HOME */}
        <SheetClose asChild>
          <Link href={`/`} className={`block text-lg ${isActive('/') ? 'text-red!' : 'text-gray-800'}`}>
            Home
          </Link>
        </SheetClose>

        <div className=' space-y-6'>
          <MobileCategorySection
            locale={locale}
            category='Collections'
            items={[
              { label: 'shineGlossy', href: '/collections/shine-glossy' },
              { label: 'classicMarbles', href: '/collections/classic-marbles' },
              { label: 'stonesMixes', href: '/collections/stones-mixes' },
              { label: 'urbanStyle', href: '/collections/urban-style' },
              { label: 'woodCollection', href: '/collections/wood-tiles' },
            ]}
          />

          {/* CATALOG */}
          <SheetClose asChild>
            <Link href={`/catalog`} className={`block text-lg ${isActive('/catalog') ? 'text-red' : 'text-gray-800'}`}>
              {t('nav.catalog')}
            </Link>
          </SheetClose>

          {/* ABOUT */}
          <SheetClose asChild>
            <Link href={`/about`} className={`block text-lg ${isActive('/about') ? 'text-red' : 'text-gray-800'}`}>
              {t('nav.about')}
            </Link>
          </SheetClose>

          <MobileLanguageSelector locale={locale} />
        </div>
        <div className='absolute bottom-6 left-0 w-full flex justify-center'>
          <LogoIconWithText />
        </div>
      </SheetContent>
    </Sheet>
  )
}
